module.exports = __webpack_public_path__ + "static/media/logo2.29f855c6.svg";